import { cn } from "@/lib/utils"

// The ChicTravel bird, theme-aware. The brand mark is dark charcoal ink (+ an
// orange belly) on transparency, so on a dark background the strokes/eye would
// vanish. We ship a light-ink variant (logo*-dark.png) and pick between them
// purely in CSS off the `.dark` class on <html> — no JS, no useTheme hook, and
// no hydration flash (both <img> are in the DOM; CSS just hides one).
//
// `className` styles BOTH imgs identically (size, rounding, object-fit), so this
// is a drop-in for the raw `<img src="/logo192.png" className=... />` it
// replaces. The 192px asset is the source for every on-screen size.
// WebP variants (logo192.webp / logo192-dark.webp) are ~75% smaller; browsers
// that support WebP pick them via <picture>, others fall back to the PNG.
export function Logo({
  className,
  alt = `ChicTravel`,
}: {
  className?: string
  alt?: string
}) {
  return (
    <>
      <picture className={cn(`block dark:hidden`, className)}>
        <source srcSet="/logo192.webp" type="image/webp" />
        <img
          src="/logo192.png"
          alt={alt}
          className={cn(`block dark:hidden`, className)}
        />
      </picture>
      <picture className={cn(`hidden dark:block`, className)}>
        <source srcSet="/logo192-dark.webp" type="image/webp" />
        <img
          src="/logo192-dark.png"
          alt={alt}
          aria-hidden
          className={cn(`hidden dark:block`, className)}
        />
      </picture>
    </>
  )
}
